// src/api/APICaller.js
import { issueRequest } from "./helpers/issueRequest";

/**
 * Generic API caller
 * @param {string} endpoint - API endpoint
 * @param {object} body - request payload (optional)
 * @param {object} options - Axios options
 * @returns {Promise<any>}
 */
export default function APICaller(endpoint, body = null, options = {}) {
  return issueRequest(endpoint, { ...options, body });
}
